import { render, staticRenderFns } from "./SpacesEditorHeader.vue?vue&type=template&id=1ca4147a&scoped=true"
import script from "./SpacesEditorHeader.js?vue&type=script&lang=js&external"
export * from "./SpacesEditorHeader.js?vue&type=script&lang=js&external"
import style0 from "./SpacesEditorHeader.scss?vue&type=style&index=0&id=1ca4147a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca4147a",
  null
  
)

export default component.exports